export type SensorCode = '100' | '101' | '102' | '103' | '104' | '105';
export const sensorType = {
  '100': 'ECG',
  '101': 'SpO2',
  '102': 'BP',
  '103': 'Temperature',
  '104': 'CGM',
  '105': 'Watch',
};

// eslint-disable-next-line no-shadow
export enum NoiseSuppressionEnum {
  ALL = 'all',
  VALIDATE = 'validate',
  FLAGFP = 'flagFP',
}

export const sensorTypeSel = [
  {
    id: '6852845225f1e3adae8d7d2d',
    name: 'ECG',
    code: '100',
  },
  {
    id: '6852845225f1e3adae8d7d2e',
    name: 'SpO2',
    code: '101',
  },
  {
    id: '6852845225f1e3adae8d7d2f',
    name: 'BP',
    code: '102',
  },
  {
    id: '6852845225f1e3adae8d7d30',
    name: 'Temperature',
    code: '103',
  },
  {
    id: '6852845225f1e3adae8d7d36',
    name: 'Watch',
    code: '105',
  },
];

export const CGMSensorType = {
  id: '6852845225f1e3adae8d7d31',
  name: 'CGM',
  code: '104',
};

export const languageMap: any = {
  zh: 'zh-CN',
  en: 'en-US',
};

export const questionaireMap: any = {
  Mobility: 'MO',
  'Self-Care': 'SC',
  'Usual Activities': 'UA',
  'Pain/Discomfort': 'PD',
  'Anxiety/Depression': 'AD',
};

export default { sensorType };
